<template>
  <q-form ref="editForm">
    <c-card title="셀렉트 컴포넌트" height="700px" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label="기본"
            name="col1"
            v-model="data.col1">
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label=""
            name="col1"
            v-model="data.col1">
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :required="true"
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label="필수값"
            name="col1"
            v-model="data.col1">
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :disabled="true"
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label="disable"
            name="col1"
            v-model="data.col1">
          </c-select>
        </div>
      </template>
    </c-card>
  </q-form>
</template>

<script>
export default {
  name: 'select',
  data() {
    return {
      editable: true,
      data: {
        col1: null,
      },
      comboItems: [
        { code: '1', codeName: '1' },
        { code: '2', codeName: '2' },
        { code: '3', codeName: '3' },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
  }
};
</script>
